
import { BrowseExtraButton, BrowseExtraButtonLocation, getBrowseExtraButtonLocationAsSelectItems } from "@/models/browse-extra-button";
import { AppBrowse, getAppBrowseAsSelectItems } from "@/utils/app-browses";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			button: new BrowseExtraButton()
		};
	},
	props: {
		value: {
			type: Object as ()=>BrowseExtraButton,
			required: true
		},
	},
	computed: {
		browseItems():ISelectItem<AppBrowse>[]{
			return getAppBrowseAsSelectItems();
		},
		locationItems():ISelectItem<BrowseExtraButtonLocation>[]{
			return getBrowseExtraButtonLocationAsSelectItems();
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.button = new BrowseExtraButton(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			this.$emit("input", this.button);
			this.close();
		}
	}
});
